import * as React from 'react';
import { Outside } from '@cian/ui-kit';
import { LocationSuggestField } from '../../../../../components/packages/GeoLocation';
import { ILocation } from '../../../../../types/location';
import { useLocationSuggest, useLocationSuggestPopup, useLocationSuggestValue } from '../../utils';

export interface ILocationContainerProps {
  onLocationChange(location?: ILocation): void;
}

export function GeoLocationSuggestFieldContainer({ onLocationChange }: ILocationContainerProps) {
  const { isSuggestShown, onItemClick, togglePopup } = useLocationSuggestPopup({ onLocationChange });

  const { getLocationSuggest, suggest, isFetching } = useLocationSuggest({ togglePopup });

  const { suggestValue, clearSuggestValue, onSuggestionValueChange } = useLocationSuggestValue({
    togglePopup,
    getLocationSuggest,
  });

  return (
    <Outside onOutside={clearSuggestValue}>
      <LocationSuggestField
        isLoading={isFetching}
        placeholder="Введите регион"
        inputValue={suggestValue}
        suggest={suggest}
        isSuggestShown={isSuggestShown}
        onChange={onSuggestionValueChange}
        onItemClick={onItemClick}
      />
    </Outside>
  );
}
